<template>
  <v-card
    class="mx-auto mt-6 page-content elevation-1"
    max-width="80%"
  >

    <popup-message ref="msg" @input="popupClosed"/>

    <v-card-text>
      <v-stepper v-model="step" class="elevation-0" alt-labels>

        <v-stepper-header class="tab-header">
          <v-stepper-step step="1" :rules="[() => this.isForm1Valid]">
            {{ $t('General') }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" :rules="[() => this.isForm2Valid]">
            {{ $t('Description') }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" :rules="[() => this.isForm3Valid]">
            {{ $t('Attach docs') }}
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" class="px-0">
            <v-form ref="form1" v-model="isForm1Valid">

            <v-container fluid>
              <v-row align="center" justify="start">
                <v-col cols="12" md="6" xl="3">
                  <v-text-field v-model="item.manifest" :label="$t('Manifest (shipment number)')" prepend-inner-icon="api"
                    :placeholder="$t('Manifest (shipment number)')"
                    solo class="text-field-bgr"
                    :rules="[rules.required]"
                    append-icon="person_search"
                    @click:append="onManifest"
                    @keydown.enter.tab="onManifest"
                    autofocus
                    :loading="loading"
                    clearable @click:clear="onCleanManifest"
                    :readonly="manifestDisable"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" xl="3">
                  <v-select v-model="item.partnerId" :label="$t('Sender')" prepend-inner-icon="account_box"
                    :placeholder="$t('Sender')"
                    solo class="text-field-bgr"
                    :rules="[rules.required]"
                    :disabled="!isBusinessPartners"
                    :items="businessPartners"
                    item-text="name" item-value="id"
                    @change="onBusinessPartner"
                    @click="isBusinessPartnersOpen = true"
                    v-click-outside="onClickOutside"
                    :menu-props="{ value: isBusinessPartnersOpen }"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6" xl="3">
                  <v-text-field v-model="item.contactName" :label="$t('Contact person')" prepend-inner-icon="person"
                    :placeholder="$t('Contact person')"
                    solo class="text-field-bgr"
                    :rules="[rules.required]"
                    :disabled="!isBusinessPartners"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" xl="3">
                  <v-text-field v-model="item.contactPhone" :label="$t('Phone')" prepend-inner-icon="phone"
                    :placeholder="$t('Phone')"
                    solo class="text-field-bgr"
                    :rules="[rules.required, rules.tel]"
                    :disabled="!isBusinessPartners"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>

                <v-col cols="12" md="6" xl="3">
                  <v-text-field v-model="item.contactEMail" :label="$t('Email')" prepend-inner-icon="email"
                    :placeholder="$t('Email')"
                    solo class="text-field-bgr"
                    :rules="[rules.required, rules.email]"
                    :disabled="!isBusinessPartners"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" xl="3">
                  <v-text-field v-model="item.iban" :label="$t('IBAN (in case of compensation)')" prepend-inner-icon="payments"
                    :placeholder="$t('IBAN (in case of compensation)')"
                    solo class="text-field-bgr"
                    :rules="[rules.iban]"
                    :disabled="!isBusinessPartners"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-spacer></v-spacer>
                <v-col class="text-right shrink">
                  <v-btn text color="primary" @click="step++" :disabled="!isForm1Valid">
                    {{ $t('Forward') }}
                    <v-icon right>arrow_forward</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            </v-form>
          </v-stepper-content>


          <v-stepper-content step="2" class="px-0">
            <v-form ref="form2" v-model="isForm2Valid">
            <v-container fluid>
              <v-row align="start" justify="start">
                <v-col cols="9" md="4" xl="2">
                  <v-text-field v-model="item.claim.amount" :label="$t('Claim value')" prepend-inner-icon="money"
                    :placeholder="$t('Claim value')"
                    solo class="text-field-bgr"
                    :rules="[ruleRequiredPrise]"
                    type="number"
                  ></v-text-field>
                </v-col >
                  <v-col cols="3" md="2" xl="1">
                  <v-select v-model="item.claim.currency" :label="$t('Currency')"
                    :placeholder="$t('Currency')"
                    :items="currencies"
                    solo class="text-field-bgr"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="6" xl="3">
                  <v-text-field v-model="item.weight" :label="$t('Damaged good (kg)')" prepend-inner-icon="scale"
                    :placeholder="$t('Damaged good (kg)')"
                    solo class="text-field-bgr"
                    :rules="[ruleRequiredWeight]"
                    type="number"
                    :suffix="$t('kg')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" lg="6" xl="3">
                  <v-select v-model="item.problemType" :label="$t('Damage nature')" prepend-inner-icon="report_problem"
                    :placeholder="$t('Damage nature')"
                    :items="problemTypes"
                    solo class="text-field-bgr"
                    :rules="[rules.required]"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="6" xl="4">
                  <v-textarea v-model="item.content" :label="$t('Description (please describe the matter in detail)')" prepend-inner-icon="comment"
                    :placeholder="$t('Description (please describe the matter in detail)')"
                    solo class="text-field-bgr"
                    :rules="[rules.required, rules.content]"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>

                <v-col cols="12" xl="6">
                  <v-checkbox dense readonly hide-details="auto"
                    :value="isConsentHasCargoInsurance"
                    :rules="[ruleConsentCargoInsurance]"
                    :disabled="isDisabledConsentCargoInsurance"
                  >
                    <template v-slot:label>
                      <div>
                        {{ $t('CONSENT.1-1') }}
                        <v-btn-toggle v-model="consentHasCargoInsurance" dense background-color="white" active-class="tp_blue white--text" class="mx-2">
                          <v-btn text :value="true"  :disabled="isDisabledConsentCargoInsurance">{{ $t('has') }}</v-btn>
                          <v-btn text :value="false" :disabled="isDisabledConsentCargoInsurance">{{ $t('has not') }}</v-btn>
                        </v-btn-toggle>
                        {{ $t('CONSENT.1-2') }}
                      </div>
                    </template>
                  </v-checkbox>

                  <v-checkbox dense hide-details="auto" :label="$t('CONSENT.2')" v-model="consents[0]" :rules="[rules.consent]"></v-checkbox>
                  <v-checkbox dense hide-details="auto" :label="$t('CONSENT.3')" v-model="consents[1]" :rules="[rules.consent]"></v-checkbox>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-left shrink">
                  <v-btn text color="tp_blue_grey" @click="step--">
                    <v-icon left>arrow_back</v-icon>
                    {{ $t('Back') }}
                  </v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-col class="text-right shrink">
                  <v-btn text color="primary" @click="step++" :disabled="!isForm2Valid">
                    {{ $t('Forward') }}
                    <v-icon right>arrow_forward</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            </v-form>
          </v-stepper-content>


          <v-stepper-content step="3" class="px-0">
            <v-form ref="form3" v-model="isForm3Valid">
            <v-container fluid>
              <v-row align="center" justify="start">
                <v-col>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-select :label="$t('Choose file')" :placeholder="$t('Choose file')"
                          v-model="attachment.type"
                          :items="attachmentTypes"
                          @change="onAttachType"
                          item-value="id"
                          prepend-inner-icon="folder_open"
                          hide-details="auto"
                          solo class="text-field-bgr"
                          truncate-length="150"
                        ></v-select>
                        <v-file-input v-model="attachment.file" :label="$t('Choose file')" :placeholder="$t('Choose file')"
                          prepend-inner-icon="folder_open" :prepend-icon="null"
                          hide-details="auto"
                          solo class="text-field-bgr d-none"
                          truncate-length="150"
                          show-size
                          @keypress.enter="onAttach" @change="onAttach"
                          ref="attachmentInput"
                        ></v-file-input>
                      </span>
                    </template>
                    {{ $t('Choose file to add to the attachments list') }}
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-row v-if="attachments.length > 0">
                <v-col>
                  <v-list outlined>

                    <template v-for="(attch, index) in attachments">
                      <v-divider inset v-if="index > 0" :key="index"></v-divider>

                      <v-list-item two-line :key="attch.name">
                        <v-list-item-avatar>
                          <v-icon class="primary" dark v-text="fileIcon(index)"></v-icon>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title>{{ attch.name }}</v-list-item-title>
                          <v-list-item-subtitle>
                            <span class="pr-10 text-xs-right">
                              <v-chip small label color="blue-grey lighten-4">{{ getAttachmentType(attch.typenum).text }}</v-chip>
                            </span>
                            <span>{{ printDatetime(attch.lastModified) }}</span>
                            <span class="pl-10">{{ fileSize(attch.size) }}</span>
                          </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on">
                              <v-btn icon @click="onDetach(index)">
                                <v-icon>delete</v-icon>
                              </v-btn>
                              </span>
                            </template>
                            {{ $t('Remove from list') }}
                          </v-tooltip>
                        </v-list-item-action>
                      </v-list-item>
                    </template>

                  </v-list>
                </v-col>
              </v-row>

              <v-row class="pt-4">
                <v-col class="text-left shrink">
                  <v-btn text color="tp_blue_grey" @click="step--">
                    <v-icon left>arrow_back</v-icon>
                    {{ $t('Back') }}
                  </v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-divider vertical></v-divider>
                <v-col class="text-right shrink">
                  <v-btn text color="success" @click="send" :disabled="!isSendEnabled"
                    :loading="sending"
                  >
                    {{ $t('Send') }}
                    <v-icon right>send</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            </v-form>
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>

    </v-card-text>
  </v-card>
</template>

<script>
import PopupMessage from '@/components/PopupMessage';
import { printDatetime } from '@/utils/helpers';

export default {
  name: 'ClaimForm',
  props: [
    'manifest'
  ],
  components: {
    PopupMessage
  },
  data() {
    return {
      loading: false,
      sending: false,
      step: 1,
      item: {
        manifest: null,
        partnerId: null,
        contactName: null,
        contactPhone: null,
        contactEMail: null,
        iban: null,
        claim: {
          amount: null,
          currency: 'EUR'
        },
        weight: null,
        problemType: null,
        content: null,
        description: null,
        insurance: null,
        attachments: {}
      },
      rules: {
        required: value => !!value || this.$t('Required field'),
        email: value => {
          const  pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('Invalid e-mail')
        },
        tel: value => {
          const  pattern = /^\+?[\d ]*$/
          return pattern.test(value) || this.$t('Invalid phone number')
        },
        iban: value => {
          // const pattern = /^\d{18}$/
          const pattern = /^.*$/
          return (!value
              || ( value && pattern.test(value))) || this.$t('Invalid IBAN')
        },
        content: value => value && value.length >= 5 || this.$t('Description must length at least 5 symbols'),
        consent: value => value || this.$t('Consent unchecked'),
      },
      isForm1Valid: false,
      isForm2Valid: false,
      isForm3Valid: false,
      wasStep3: false,
      // Helper fields
      businessPartners: [],
      problemTypes: [
        { value: 'MISSING',   text: this.$t('Missing or robbed shipment')            },
        { value: 'DAMAGE',    text: this.$t('Damaged shipment')                      },
        { value: 'DEVIATION', text: this.$t('Non-compliance with the delivery time') },
        { value: 'OTHER',     text: this.$t('Other')                                 },
      ],
      isBusinessPartnersOpen: false,
      consents: [],
      consentHasCargoInsurance: undefined,
      //
      attachment: { file: null, type: null },
      attachments: [],
      attachmentTypes: [
        { id: 'PROOF_SHIPMENT_VALUE', text: this.$t('ATTACHMENT_TYPE.PROOF_SHIPMENT_VALUE') },
        { id: 'INSURANCE',            text: this.$t('ATTACHMENT_TYPE.INSURANCE') },
        { id: 'PACKING',              text: this.$t('ATTACHMENT_TYPE.PACKING') },
        { id: 'POD',                  text: this.$t('ATTACHMENT_TYPE.POD') },
        { id: 'CMR',                  text: this.$t('ATTACHMENT_TYPE.CMR') },
        { id: 'PROOF_PAID_INVOICE',   text: this.$t('ATTACHMENT_TYPE.PROOF_PAID_INVOICE') },
        { id: 'STOCK_CONTROL',        text: this.$t('ATTACHMENT_TYPE.STOCK_CONTROL') },
        { id: 'PHOTOS',               text: this.$t('ATTACHMENT_TYPE.PHOTOS') },
        { id: 'TRADE_DISCOUNT',       text: this.$t('ATTACHMENT_TYPE.TRADE_DISCOUNT') },
        { id: 'COMPENSATION_CLAIM',   text: this.$t('ATTACHMENT_TYPE.COMPENSATION_CLAIM') },
        { id: 'OTHERS',               text: this.$t('ATTACHMENT_TYPE.OTHERS') },
      ],
      files: [
        { type: 'image',        icon: 'photo',                   regex: /(jpe?g|png|gif)/i       },
        { type: 'pdf',          icon: 'picture_as_pdf',          regex: /pdf/i                   },
        { type: 'doc',          icon: 'text_snippet',            regex: /(te?xt|docx?|rtf|otf)/i },
        { type: 'sheet',        icon: 'photo_size_select_small', regex: /(xlsx?|ots)/i           },
        { type: 'presentation', icon: 'insert_chart',            regex: /(pptx?|otpx?)/i         },
        { type: 'misc',         icon: 'insert_drive_file',       regex: /.*/i                    },
      ],
      manifestDisable: false,
      currencies: [
        { value: 'EUR',       text: '€'            },
        { value: 'BGN',       text: this.$t('lv.') }
      ],
    }
  },
  computed: {
    isSendEnabled() {
      return this.isForm1Valid && this.isForm2Valid && this.isForm3Valid && this.wasStep3;
    },
    isBusinessPartners() {
      return Array.isArray(this.businessPartners) && this.businessPartners.length > 0;
    },
    isProblemTypeRequirable() {
      return this.item.problemType === 'MISSING' || this.item.problemType === 'DAMAGE';
    },
    ruleRequiredPrise() {
      return (!this.isProblemTypeRequirable || this.isProblemTypeRequirable && this.item.claim?.amount > 0) || this.$t('Required field');
    },
    ruleRequiredWeight() {
      return (!this.isProblemTypeRequirable || this.isProblemTypeRequirable && this.item.weight > 0) || this.$t('Required field');
    },
    isConsentHasCargoInsurance() {
      return typeof this.consentHasCargoInsurance !== 'undefined';
    },
    ruleConsentCargoInsurance() {
      return (!this.isProblemTypeRequirable || this.isProblemTypeRequirable && this.isConsentHasCargoInsurance) || this.$t('Consent unchecked');
    },
    isDisabledConsentCargoInsurance() {
      return !this.isProblemTypeRequirable;
    },
  },
  methods: {
    onManifest() {

      if (this.loading || !this.item.manifest) {
        return;
      }
      this.loading = true;

      this.$http.get('integration/case/partners.svc', {
          params: {
            manifest: this.item.manifest
          }
        })
        .then(response => {

          if (response?.body && response.body.length > 0) {
            let bps = [];
            response.body.forEach(elem => {
              elem.name = this.$t(elem.name);

              let existingElem = bps.find(eElem => eElem.id === elem.id);
              if (existingElem) {
                existingElem.name += '/' + elem.name;
              }
              else {
                bps.push(elem);
              }
            });
            this.businessPartners = bps;

            if (this.businessPartners.length === 1) {
              this.item.partnerId = this.businessPartners[0].id;
              this.onBusinessPartner();
            }
            else {
              this.isBusinessPartnersOpen = true;
            }

            this.manifestDisable = true;
          }
        })
        .catch(err => {
          this.$refs.msg.popup( err.body.message || this.$t('Manifest cannot be loaded'), 'error');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBusinessPartner() {
      return;// 2023-08-16 stop populating personal data
      const bp = this.businessPartners.find(elem => elem.id === this.item.partnerId);
      if (bp?.contact_person) {
        this.item.contactName  = bp.contact_person;
      }
      if (bp?.contact_phone) {
        this.item.contactPhone = bp.contact_phone;
      }
    },
    onClickOutside() {
      this.isBusinessPartnersOpen = false;
    },
    onCleanManifest() {
      this.cleanData();
      this.manifestDisable = false;
    },
    getAttachmentType(id) {
      return this.attachmentTypes.find(elem => elem.id === id) || {};
    },
    onAttachType() {
      this.$refs.attachmentInput.$el.querySelector('input').click();
    },
    onAttach() {
      console.log('onAttach', this.attachment.file);// file = File { name: "Forest Sunset.col", lastModified: 1403184460000, webkitRelativePath: "", size: 286, type: "" }
      if (!this.attachment.file) {
        return;
      }
      this.attachment.file.formid = 'attachment_' + (this.attachments.length + 1);
      this.attachment.file.typenum = this.attachment.type;
      this.attachments.push(this.attachment.file);
      this.attachment  = { file: null, type: null };
    },
    onDetach(index) {
      console.log('onDetach');
      this.attachments.splice(index, 1);
    },
    fileIcon(index) {
      const filename = this.attachments[index].name;
      let ext = filename.substr( filename.lastIndexOf('.') + 1 );

      const parts = this.attachments[index].type.split('/');
      const type = parts[0];
      if (!ext)
        ext = parts[1];

      const match = this.files.find(elem => elem.regex.test(ext) || elem.type === type);
      return match.icon;
    },
    fileSize(bytes) {
      let prefix = '';
      [ {num: 1000000, prefix: 'M'},
        {num: 1000,    prefix: 'K'}
      ].forEach(elem => {
        if (bytes > elem.num) {
          bytes /= elem.num;
          prefix = elem.prefix;
          return;
        }
      });
      return `${bytes.toFixed(2)} ${prefix}B`;
    },
    send() {
      if (this.sending) {
        return;
      }
      this.sending = true;

      let item = Object.assign({}, this.item);
      {

        if (item.weight && !isNaN(item.weight)) {
          item.weight = Number(item.weight);
        }
        if (item.claim && !isNaN(item.claim)) {
          item.claim.amount = Number(item.claim.amount);
        }

        item.description = item.content;
        item.insurance = this.isConsentHasCargoInsurance ? this.consentHasCargoInsurance : null;

        // Content
        if (item.iban) {
          item.content += '\nIBAN=' + item.iban;
        }
        item.content += '\n';
        if (this.isConsentHasCargoInsurance) {
          item.content += '\nCargo insurance=' + (this.consentHasCargoInsurance ? this.$t('has') : this.$t('has not'));
        }
        item.attachments = {};
        this.attachments.forEach((file, index) => {
          item.content += '\nAttachment#' + (index+1) + ': ' + file.formid + '=' + this.getAttachmentType(file.typenum).text;
          item.attachments[file.formid] = file.typenum;
        });
      }

      let form = new FormData();
      form.append('wfcs', JSON.stringify( item ));
      this.attachments.forEach(file => {
        form.append(file.formid, file, file.name);
      });

      this.$http.post('integration/case/save.svc', form, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          let claimNo = response?.body?.wfcsId || null;
          this.$refs.msg.popup( this.$t('CLAIM_FORM_SAVE.SUCCESS', {claimNo}), 'success', claimNo ? 0 : undefined);
        })
        .catch(err => {
          this.$refs.msg.popup(
            err.status === 400 || err.status === 404 ? err.body : this.$t('Server error')
          , 'error');
        })
        .finally(() => {
          this.sending = false;
        });
    },

    printDatetime(d) {
      return printDatetime(d);
    },

    popupClosed(e) {
      // restart after success application
      if (e.type === "success") {
        this.step = 1;
        this.cleanData();
      }
    },

    cleanData() {
     // this.item = {};
      Object.assign(this.item,
      {
        manifest: null,
        partnerId: null,
        contactName: null,
        contactPhone: null,
        contactEMail: null,
        iban: null,
        claim: {
          amount: null,
          currency: 'EUR'
        },
        weight: null,
        problemType: null,
        content: null,
        description: null,
        insurance: null,
        attachments: {}
      });
      this.wasStep3 = false;
      this.businessPartners = [];
      this.consentHasCargoInsurance = undefined;
      this.consents = [];
      this.attachment  = { file: null, typeId: null };
      this.attachments = [];
    }
  },
  mounted() {
    if (this.manifest) {
      this.item.manifest = this.manifest;
      this.onManifest();
    }
  },
  watch: {
    step(val) {
      if (val == 3) {
        this.wasStep3 = true;
      }
    }
  }
}
</script>

<style scoped>
.theme--light.v-stepper {
	background: transparent;
}
.tab-header {
	box-shadow: none;
  box-shadow: 0px 1px 7px -3px rgba(0, 0, 0, 0.7);
  background: radial-gradient(ellipse at center bottom, rgb(255, 255, 255) 30%, rgba(179, 220, 255, 0) 70%);
}

.page-content {
  background: rgba(0, 0, 0, 0) radial-gradient(circle at center top, rgb(250, 252, 253) 40%, rgba(179, 220, 255, 0.63) 100%) repeat scroll 0% 0%;
  background: radial-gradient(circle at center top, rgb(240, 247, 251) 40%, rgba(179, 220, 255, 0.6) 100%);
}
</style>
